import classNames from 'classnames';
import isFirefox from 'is-firefox';
import React, { useCallback } from 'react';
import './Button.scss';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  primary?: boolean
  disabled?: boolean
  innerRef?: React.Ref<HTMLButtonElement>
}

export default function Button({ primary, className, disabled, onMouseDown, onClick, innerRef, ...props }: React.PropsWithChildren<Props>) {
  const preventFocus = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    if (!isFirefox) {
      e.preventDefault()
      return
    }

    if (disabled) { return }

    const target = e.currentTarget
    const active = document.activeElement as unknown
    setTimeout(() => {
      target.blur();
      (active as HTMLOrSVGElement).focus()
    }, 0)

    onMouseDown && onMouseDown(e)
  }, [onMouseDown, disabled])

  const handleClick = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    if (!disabled && onClick) {
      onClick(e)
    }
  }, [disabled, onClick])

  return <button className={classNames('Button', primary && 'primary', disabled && 'disabled', className)}
    ref={innerRef} {...props} onMouseDown={preventFocus} onClick={handleClick} />
}
